import React, { Component } from "react";
import { connect, DispatchProp } from "react-redux";
import { Alert, Button } from "reactstrap";
import { AppState } from "../../store";
import { getLocation } from "../../store/actions";
type Props = ReturnType<typeof mapStateToProps> & DispatchProp<any>;
class LocationAlert extends Component<Props, { visible: boolean }> {
  constructor(props: Props) {
    super(props);

    this.state = {
      visible: true,
    };

    this.onDismiss = this.onDismiss.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  public onDismiss() {
    this.setState({ visible: false });
  }

  public onClick() {
    this.props.dispatch(getLocation());
  }
  public render() {
    const { status } = this.props;
    switch (status) {
      case "NO_LOCATION":
        return (
          <Button
            className="alert"
            onClick={this.onClick}
            color="primary"
            style={{
              position: "absolute",
              zIndex: 1,
              width: "100%",
              fontSize: "2em",
            }}
          >
            Order By Distance
          </Button>
        );
      case "":
      case "LOCATED":
        return "";
      case "PERMISSION_DENIED":
        return (
          <Alert
            color="info"
            style={{ position: "absolute", zIndex: 1, width: "100%" }}
            isOpen={this.state.visible}
            toggle={this.onDismiss}
          >
            Geolocation is not enabled.
          </Alert>
        );
      case "LOCATION_NOT_SUPPORTED":
        return (
          <Alert
            color="info"
            style={{ position: "absolute", zIndex: 1, width: "100%" }}
            isOpen={this.state.visible}
            toggle={this.onDismiss}
          >
            Your browser does not support Geolocation.
          </Alert>
        );
      default:
        return "";
    }
  }
}

function mapStateToProps(state: AppState) {
  return {
    status: state.location.status,
  };
}

export default connect(mapStateToProps)(LocationAlert);
